'use strict';

import _ from 'lodash';
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import cx from 'classnames';
import moment from 'moment';

import Drawer from 'material-ui/Drawer';
import TackIcon from '../../../common/svgs/TackIcon';
import ChevronIcon from '../../../common/svgs/ChevronIcon';
import CloseX from '../../../common/svgs/CloseX';
import GenericCard from './GenericCard';
import localDate from '../../../lib/localDate';
import prettyPhone from '../../../lib/prettyPhone';

import {lookup, getLookupValue} from '../../../redux/helpers/staticData';

import { getPins, updatePins } from '../../../redux/actionCreators/async/employees';
import * as syncActionCreators from '../../../redux/actionCreators/sync';
import * as ui from '../../../redux/actionCreators/sync/ui';

@connect((state) => {
  const statuses = state.staticData.applicantStatus;
  const applicants = _(state.pins.applicants)
    .map(applicant =>
      _.chain(statuses)
      .find({id: applicant.profile.applicantStatus.id})
      .pick(['color', 'label', 'lifespan'])
      .merge(applicant)
      .value()
    )
    .value();


  return {
    staticData: state.staticData,
    applicants,
    contacts: state.pins.contacts,
    companies: state.pins.companies,
    jobRequests: state.pins.jobRequests,
    pinnedData: state.pins.pinned
  };
})
export default class CorkBoard extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
  }

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      showApplicants: true,
      showContacts: true,
      showCompanies: true,
      showJobRequests: true
    };
  }

  componentWillMount() {
    const { dispatch } = this.props;
    dispatch(getPins((err, pins) => {
      if (!err) {
        dispatch(syncActionCreators.loadPins(pins))}
      }
    ));
  }

  handleToggle = () => this.setState({open: !this.state.open});

  goToApplicant = (id) => {
    return () => {
      this.props.dispatch(ui.showSpinner());
      this.props.dispatch(push(`/admin/In Process/${id}/Profile?detail=1`));
    }
  }

  goToContact = (id) => {
    return () => {
      this.props.dispatch(ui.showSpinner());
      this.props.dispatch(push(`/admin/contacts/${id}/details`));
    }
  }

  goToCompany = (id) => {
    return () => {
      this.props.dispatch(ui.showSpinner());
      this.props.dispatch(push(`/admin/companies/${id}/details`));
    }
  }

  goToJobRequest = (id) => {
    return () => {
      this.props.dispatch(ui.showSpinner());
      this.props.dispatch(push(`/admin/jobrequests/${id}`));
    }
  }

  unpin = (type, id) => {
    return (event) => {
      let newPinnedData = this.props.pinnedData;
      _.pull(newPinnedData[type], id)
      this.props.dispatch(updatePins(newPinnedData, (err, pins) => {
        if (!err) {
          this.props.dispatch(syncActionCreators.loadPins(pins))}
        }
      ));
      event.stopPropagation();
    }
  }

  render() {
    const isEmpty = !(this.props.applicants.length);
    return (
      <div className='cork-board'>
        <Drawer
          containerClassName={'pin-drawer'}
          docked
          width={(this.state.open) ? 346 : 60}
          openSecondary
          open
          containerStyle={{overflow: 'hidden'}}
          >
          <div className={`pinned-container`} onClick={!this.state.open && this.handleToggle}>
            <div onClick={this.state.open && this.handleToggle}
              className={`bar${((this.state.open) ? '' : ' closed')}`} >
              <TackIcon />
              <div className='title'>Pinned</div>
              <div className='closeIcon'>Close <CloseX /></div>
            </div>
            {
              this.state.open
              &&
              <div className='pinned-items' data-id='pinned-items'>
                {this.props.applicants.length > 0
                  &&
                  <div className='title-bar' onClick={() => this.setState({showApplicants: !this.state.showApplicants})}>
                    <span className={cx('wv-chevron', {flipped: !this.state.showApplicants})}>
                      <ChevronIcon color='#FFF' />
                    </span>
                    <div className='title'>Candidates</div>
                  </div>
                }
                {this.state.showApplicants && _.map(this.props.applicants, (applicant) =>
                    <div onClick={this.goToApplicant(applicant.profile.id)}>
                      <GenericCard
                        key={applicant.profile.id}
                        data-id={applicant.profile.id}
                        title={`${applicant.user.firstName} ${applicant.user.lastName}`}
                        color={applicant.color}
                        unpin={this.unpin('applicants', applicant.profile.id)}
                        content={[
                          applicant.user.email,
                          `Availability: ${localDate(applicant.profile.availabilityDate)}`,
                          prettyPhone(applicant.user.phoneNumber1),
                          `Applied: ${localDate(applicant.profile.dateCreated)}`
                        ]}
                      />
                    </div>
                  )
                }

                {this.props.contacts.length > 0
                  &&
                  <div className='title-bar' onClick={() => this.setState({showContacts: !this.state.showContacts})}>
                    <span className={cx('wv-chevron', {flipped: !this.state.showContacts})}>
                      <ChevronIcon color='#FFF' />
                    </span>
                    <div className='title'>Contacts</div>
                  </div>
                }
                {this.state.showContacts && _.map(this.props.contacts, (contact) => {
                  const status = getLookupValue(this.props.staticData, 'companyStatus', {id: contact.company.companyStatus});
                  const followUpTask = _(contact.profile.tasks)
                                          .filter(task => task.taskFollowUpDate && (new Date(task.taskFollowUpDate) - Date.now() > 0))
                                          .sortBy(task => new Date(task.taskFollowUpDate))
                                          .head();
                  return <div onClick={this.goToContact(contact.profile.id)}>
                    <GenericCard
                      key={contact.profile.id}
                      data-id={contact.profile.id}
                      title={`${contact.user.firstName} ${contact.user.lastName}`}
                      color={status.color}
                      unpin={this.unpin('contacts', contact.profile.id)}
                      content={[
                        contact.profile.title,
                        contact.company.name,
                        contact.user.email,
                        `Contacted: ${localDate(contact.profile.dateCreated)}`,
                        prettyPhone(contact.user.phoneNumber1),
                        `Follow Up: ${followUpTask ? moment(followUpTask.taskFollowUpDate).format('L') : ''}`
                      ]}
                    />
                  </div>
                })}

                {this.props.companies.length > 0
                  &&
                  <div className='title-bar' onClick={() => this.setState({showCompanies: !this.state.showCompanies})}>
                    <span className={cx('wv-chevron', {flipped: !this.state.showCompanies})}>
                      <ChevronIcon color='#FFF' />
                    </span>
                    <div className='title'>Companies</div>
                  </div>
                }
                {this.state.showCompanies && _.map(this.props.companies, (company) => {
                  const status = getLookupValue(this.props.staticData, 'companyStatus', {id: company.companyStatus});
                  return <div onClick={this.goToCompany(company.id)}>
                    <GenericCard
                      key={company.id}
                      data-id={company.id}
                      title={company.name}
                      color={status.color}
                      unpin={this.unpin('companies', company.id)}
                      content={[
                        lookup(this.props.staticData, 'industryTypesList', {id: company.industryTypes[0]}),
                        `Entered: ${localDate(company.dateCreated)}`,
                        prettyPhone(company.phoneNumber),
                        `Updated: ${localDate(company.dateModified)}`,
                      ]}
                    />
                  </div>
                })}

                {this.props.jobRequests.length > 0
                  &&
                  <div className='title-bar' onClick={() => this.setState({showJobRequests: !this.state.showJobRequests})}>
                    <span className={cx('wv-chevron', {flipped: !this.state.showJobRequests})}>
                      <ChevronIcon color='#FFF' />
                    </span>
                    <div className='title'>Job Requests</div>
                  </div>
                }
                {this.state.showJobRequests && _.map(this.props.jobRequests, (jobRequest) => {
                  const status = getLookupValue(this.props.staticData, 'jobRequestStatus', {id: jobRequest.jobRequestStatus});
                  const positionTitle = lookup(this.props.staticData, 'positionTypes', {id: jobRequest.positionTypeId});
                  return <div onClick={this.goToJobRequest(jobRequest.id)}>
                    <GenericCard
                      key={jobRequest.id}
                      data-id={jobRequest.id}
                      title={positionTitle}
                      color={status.color}
                      unpin={this.unpin('jobRequests', jobRequest.id)}
                      content={[
                        `#${jobRequest.id}`,
                        jobRequest.primaryContact,
                        lookup(this.props.staticData, 'industryTypesList', {id: jobRequest.industryTypeId}),
                        jobRequest.companyName,
                        '',
                        `Date Added: ${localDate(jobRequest.dateCreated)}`
                      ]}
                    />
                  </div>
                })}
              </div>
            }
          </div>
        </Drawer>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/CorkBoard/index.js